import {
    SIGN_UP,
} from '../actions/types';

const signupReducer = (state = {}, action) => {
    switch (action.type) {
        case SIGN_UP:
            return {...state, businessname: action.payload.business.businessname, customer_id: action.payload.user.customer_id, email: action.payload.user.email}
        default:
            return state
    }
};

export default signupReducer;